enum SortingType {
  ASC = 'asc',
  DESC = 'desc',
}

export default SortingType
